// Where a floating box goes (the comments' preview and thread window, the Gantt's action popover):
// kept 8px inside the viewport (old clampXY and place, DP:8392-8402). Pure, tested without a browser.

export type XY = [number, number];
export interface Size {
  w: number;
  h: number;
}

/** Keeps a box of `size` 8px inside the viewport (old clampXY). */
export function clampXY([x, y]: XY, size: Size, view: Size): XY {
  return [Math.round(Math.max(8, Math.min(x, view.w - size.w - 8))), Math.round(Math.max(8, Math.min(y, view.h - size.h - 8)))];
}

/** Under the chip, left edges aligned; above it when there is no room below (old place). */
export function placeBelow(chip: { left: number; top: number; bottom: number }, size: Size, view: Size): XY {
  const [left] = clampXY([chip.left, 0], size, view);
  let top = chip.bottom + 8;
  if (top + size.h > view.h - 8) top = Math.max(8, chip.top - size.h - 8);
  return [left, Math.round(top)];
}

/** A drawn box's size. */
export const sizeOf = (el: HTMLElement): Size => ({ w: el.offsetWidth, h: el.offsetHeight });

/** The browser window's size. */
export const viewport = (): Size => ({ w: window.innerWidth, h: window.innerHeight });
